<section>
  <ul class="header-notifications-menu" aria-labelledby="dropdownMenuButton" *ngIf="notifications">
    <li *ngFor="let notification of notifications; let n = index">
      <a class="dropdown-item new_noti" [routerLink]="notification.notificationLink">
        <div class="clearfix flex-box">
          <div class="noti_ico"><i class="type"></i></div>
          <div class="noti_data" *ngIf="notification && notification.notificationText">
            {{ notification.notificationText.textAr }}
            <p class="time speero-date">{{ notification.createdAt | date: 'yyyy/MM/dd hh:mm a' }}</p>
          </div>
        </div>
      </a>
    </li>
  </ul>
</section>
